var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"page-detail"},[(_vm.page.bodyType === 0)?_c('div',{staticClass:"fr-view",domProps:{"innerHTML":_vm._s(_vm.page.body)}}):_c('iframe',{staticStyle:{"width":"100%","border":"none","height":"100%"},attrs:{"src":_vm.page.body}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bcf95ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PageDetail.vue
// module id = null
// module chunks = 